import MyCustomerTab from './MyCustomerTab';

const CompletedTab = () => <MyCustomerTab mode="completed" />;

export default CompletedTab;
